<template>
  <div class="prodGroup">
    <el-popover ref="prodListPopover" placement="bottom-start" trigger="click" popper-class="prodPopover">
      <el-tree
        :data="prodList"
        :props="prodListTreeProps"
        node-key="prn"
        ref="prodListTree"
        @current-change="prodListTreeCurrentChangeHandle"
        :default-expand-all="true"
        :highlight-current="true"
        :expand-on-click-node="false"
      >
      </el-tree>
    </el-popover>
    <el-input v-model="$attrs.model[item.field]" v-popover:prodListPopover :readonly="true" placeholder="点击选择产品" suffix-icon="el-icon-search" class="menu-list__input"></el-input>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  data() {
    return {
      prodList: [],
      prodListTreeProps: {
        label: "goodsName",
        children: "childrenList",
      },
    };
  },
  created() {
    console.log(this.item);
    console.log(this.$listeners);

    this.$http
      .get(this.$api.goodsApi.limsCatType, { params: { st: 1 } })
      .then(({ data }) => {
        this.prodList = data.data;
      })
      .then(() => {
        this.prodListTreeSetCurrentNode();
      });
  },
  methods: {
    // 产品树选中
    prodListTreeCurrentChangeHandle(data) {
      console.log(data);
      if (!data.isGoods) {
        this.$message({
          message: "警告，只能选择产品",
          type: "warning",
        });
        return;
      }
      console.log(this.item);
      this.item.prn = data.prn;
      this.$attrs.model[this.item.field] = data.goodsName;
      const { updateProd } = this.$listeners;
      updateProd(data.prn);
    },
    // 菜单树设置当前选中节点
    prodListTreeSetCurrentNode() {
      this.$refs.prodListTree.setCurrentKey(this.item.prn);
      this.$attrs.model[this.item.field] = (this.$refs.prodListTree.getCurrentNode() || {})["goodsName"];
    },
  },
};
</script>

<style lang="scss">
.prodPopover {
  height: 260px;
  overflow: auto;
}
</style>
